<template>
  <Modal
    :title="`Edit Appointment ${appointment?.id ? `#${appointment.id}` : ''}`"
    class-name="edit-appt-modal"
    @hide-modal="handleClose"
  >
    <div v-if="appointment">
      <EditAppointmentHeader :appointment="appointment" />
      <component :is="editComponent" :appointment="appointment"></component>
      <div v-if="canCancel">
        <Button
          v-if="!confirmationOpen"
          icon="fas fa-calendar-times"
          text="Cancel Appointment"
          class="mt-4"
          type="danger"
          @click="toggleConfirmationOpen"
        ></Button>
        <appointment-cancel-confirmation
          v-if="confirmationOpen"
          @close-confirmation="toggleConfirmationOpen"
        ></appointment-cancel-confirmation>
      </div>
    </div>
    <div v-if="loading">
      <Spinner message="Loading appointment details..." />
    </div>
    <template #footer>
      <div></div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { updateQueryParam } from "@/lib/url.js";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";
import CONSTANTS from "@/Constants.js";
import AppointmentCancelConfirmation from "./AppointmentCancelConfirmation.vue";
import EditAppointmentHeader from "./EditAppointmentHeader.vue";
import CompletedEditMode from "./modes/CompletedEditMode.vue";
import InProgressEditMode from "./modes/InProgressEditMode.vue";
import PendingEditMode from "./modes/PendingEditMode.vue";
const { APPOINTMENT_EDIT_MODE, EDIT_MODE_IN_PROGRESS, EDIT_MODE_COMPLETED } =
  CONSTANTS;

export default {
  components: {
    AppointmentCancelConfirmation,
    EditAppointmentHeader,
    Modal,
    Spinner,
    Button
  },
  props: {
    appointmentId: {
      type: Number,
      default: null
    },
    cancelAppointment: {
      type: Boolean,
      default: false
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      open: false,
      loading: false,
      confirmationOpen: !!this.cancelAppointment
    };
  },
  computed: {
    ...mapState({
      appointment: "appointment",
      editComponent({ appointment }) {
        switch (APPOINTMENT_EDIT_MODE[appointment.status]) {
          case EDIT_MODE_IN_PROGRESS: {
            return InProgressEditMode;
          }
          case EDIT_MODE_COMPLETED: {
            return CompletedEditMode;
          }
          default: {
            return PendingEditMode;
          }
        }
      },
      canCancel({ appointment }) {
        if (!appointment) {
          return false;
        }
        return !!appointment.links.cancel;
      }
    })
  },
  mounted() {
    this.loadAppointment();
  },
  methods: {
    ...mapActions(["fetchAppointment", "clearAppointment"]),
    loadAppointment() {
      this.loading = true;
      this.fetchAppointment(this.appointmentId).then(
        () => (this.loading = false)
      );
    },
    async handleClose() {
      await updateQueryParam("appointment_id", null, true);
      this.clearAppointment();
      this.$emit("hide-modal");
    },
    toggleConfirmationOpen() {
      this.confirmationOpen = !this.confirmationOpen;
    }
  }
};
</script>

<style lang="scss">
.edit-appt-modal {
  .modal-body {
    border-radius: 0 0 4px 4px;
  }
}
</style>
